import { Section } from './Section.jsx';
import { T } from '../T.jsx';

// Names and roles carry their own i18n keys in the original markup — they are
// translated along with the quote, so they stay inside <T>.
const QUOTES = [
  {
    id: 1,
    glow: 'var(--glow-e)',
    accent: 'var(--accent-e)',
    initials: 'SP',
    textKey: 'ml_testimonial_1_text',
    text: `MyLecture cut my lecture prep time in half. The AI content generation is
      incredibly smart — it understands my topic and creates professional slides
      that I only need to fine-tune.`,
    nameKey: 'ml_testimonial_1_name',
    name: 'Dr. Sarah Park',
    roleKey: 'ml_testimonial_1_role',
    role: 'Professor of Computer Science',
  },
  {
    id: 2,
    glow: 'var(--glow-d)',
    accent: 'var(--accent-d)',
    initials: 'MR',
    textKey: 'ml_testimonial_2_text',
    text: `The live presentation features are a game-changer. My students stay engaged
      with real-time polls and Q&A, and the auto-generated summaries help them
      study more effectively.`,
    nameKey: 'ml_testimonial_2_name',
    name: 'Prof. Marco Rossi',
    roleKey: 'ml_testimonial_2_role',
    role: 'Associate Professor of Engineering',
  },
  {
    id: 3,
    glow: 'var(--glow-i2)',
    accent: 'var(--accent-i2)',
    initials: 'LC',
    textKey: 'ml_testimonial_3_text',
    text: `As an administrator, I love the centralized dashboard. Managing templates,
      tracking usage across departments, and ensuring consistent branding has
      never been easier.`,
    nameKey: 'ml_testimonial_3_name',
    name: 'Dr. Li Chen',
    roleKey: 'ml_testimonial_3_role',
    role: 'Director of Academic Technology',
  },
];

export function Testimonials() {
  return (
    <Section>
      <section className="section" id="testimonials">
        <T k="ml_testimonials_label" className="section-label">Reviews</T>
        <T k="ml_testimonials_heading" as="h2" className="section-heading fade-in">
          What Educators Are Saying
        </T>
        <T k="ml_testimonials_intro" as="p" className="section-intro fade-in">
          Hear from teachers and administrators who have transformed their lectures with MyLecture.
        </T>
        <div className="testimonials-grid">
          {QUOTES.map((q) => (
            <div className="testimonial-card fade-in" key={q.id}>
              <div className="testimonial-quote">&ldquo;</div>
              <T k={q.textKey} as="p">{q.text}</T>
              <div className="testimonial-author">
                <div className="testimonial-avatar" style={{ background: q.glow, color: q.accent }}>
                  {q.initials}
                </div>
                <div>
                  <T k={q.nameKey} as="strong">{q.name}</T>
                  <T k={q.roleKey}>{q.role}</T>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </Section>
  );
}
